import styled from 'styled-components';
import { COLORS } from '../../../game/data/colors';

export const BigButton = styled.div(() => ({
  width: 60,
  height: 50,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  '& img': {
    width: 30,
    height: 30,
    display: 'block',
    margin: 'auto',
  },
  margin: 0,
  backgroundColor: COLORS.zinc_600,
  color: 'white',
  borderRadius: 4,
  padding: 4,
  fontSize: '0.8rem',
  fontWeight: 500,
  cursor: 'pointer',
  borderBottom: `4px solid ${COLORS.zinc_800}`,
  '&:hover': {
    backgroundColor: COLORS.zinc_700,
  },
  '&:active': {
    backgroundColor: COLORS.zinc_800,
    borderTop: `4px solid ${COLORS.zinc_900}`, // this only works if the background has zinc_800 color
    borderBottom: 'none',
    borderRadius: '6px 6px 4px 4px',
  },
}));
